import { BsArrowUpRight } from "@react-icons/all-files/bs/BsArrowUpRight";
import { Link } from "gatsby";
import React from "react";
import formatDate from "../util/formatDate";
import getAuthorImgSrc from "../util/getAuthorImgSrc";
import ExcerptDetails from "./ExcerptDetails";
import * as css from "./FeaturedBlog.module.css";

type BlogPostExcerptProps = {
  data: Queries.SitePageContextBlogNode;
  elementType?: string;
};

export default function FeaturedBlog({
  data,
  elementType = "div",
}: BlogPostExcerptProps) {
  if (!data.fields || !data.frontmatter || !data.fields.slug) {
    return null;
  }
  const { author, authorHref } = data.frontmatter;
  const authorDetails = authorHref ? <a href={authorHref}>{author}</a> : author;

  const authorImgSrc = author && getAuthorImgSrc(author);

  const authorImg = authorImgSrc && (
    <img className={css.authorImg} src={authorImgSrc} alt="" />
  );

  return React.createElement(
    elementType,
    { className: css.featuredBlog },
    <>
      <div className={css.whiteDiagonal} />
      <div className={css.blogExcerpt}>
        <ExcerptDetails
          tags={data.frontmatter.tags}
          timeToRead={data.timeToRead}
        />
        <div className={css.middle}>
          <header>
            <h1>
              <Link to={data.fields.slug} className={css.titleLink}>
                {data.frontmatter.title}
              </Link>
            </h1>
            <div className={css.authorDetails}>
              {authorImg}
              <span>
                {authorDetails}
                {data.frontmatter.date && (
                  <span>
                    | <time>{formatDate(data.frontmatter.date)}</time>{" "}
                  </span>
                )}
              </span>
            </div>
          </header>
          <div className={css.excerpt}>
            <p>{data.excerpt}</p>
            <Link to={data.fields.slug}>
              Read More <BsArrowUpRight />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
